export interface AdminItem<T = any> {
  readonly dbId: number;
  readonly contentType: string;
  readonly contentId: number;
  readonly name: string;
  readonly isCustom: boolean;
  /** Veio do acervo e foi editado no painel: a reimportação não o sobrescreve. */
  readonly isEdited?: boolean;
  readonly updatedAt: string;
  readonly data: T;
}

export async function fetchAdminContent<T>(type: string): Promise<AdminItem<T>[]> {
  const res = await fetch(`/api/admin/content/${type}`, { credentials: 'include' });
  if (!res.ok) {
    throw new Error(`Falha ao carregar ${type}: HTTP ${res.status}`);
  }
  const json = (await res.json()) as { items: AdminItem<T>[] };
  return json.items;
}

export async function saveAdminContent<T>(
  type: string,
  id: number | null,
  data: Partial<T> & { name: string },
): Promise<{ ok: boolean; item?: AdminItem<T>; message?: string }> {
  const url = id ? `/api/admin/content/${type}/${id}` : `/api/admin/content/${type}`;
  const method = id ? 'PUT' : 'POST';

  try {
    const res = await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(data),
    });

    const json = await res.json();
    if (!res.ok) {
      return { ok: false, message: json.error?.message ?? `Erro HTTP ${res.status}` };
    }
    return { ok: true, item: json.item };
  } catch (e) {
    return { ok: false, message: e instanceof Error ? e.message : String(e) };
  }
}

export async function deleteAdminContent(
  type: string,
  id: number,
): Promise<{ ok: boolean; message?: string }> {
  try {
    const res = await fetch(`/api/admin/content/${type}/${id}`, {
      method: 'DELETE',
      credentials: 'include',
    });
    const json = await res.json();
    if (!res.ok) {
      return { ok: false, message: json.error?.message ?? `Erro HTTP ${res.status}` };
    }
    return { ok: true };
  } catch (e) {
    return { ok: false, message: e instanceof Error ? e.message : String(e) };
  }
}

